// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button__QI7b2","ButtonBack":"Button__ButtonBack__2Ckpa","ButtonPositive":"Button__ButtonPositive__2U3NK","ButtonNegative":"Button__ButtonNegative__EjX1c","ButtonDisabled":"Button__ButtonDisabled__1y3J_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 134
// module chunks = 0